<script lang="ts" setup>
import { type ParsedBreadcrumb } from './types';
import VBreadcrumbItem from './VBreadcrumbItem.vue';

const props = withDefaults(
  defineProps<{
    items?: ParsedBreadcrumb[];
  }>(),
  {
    items: () => [],
  },
);
</script>

<template>
  <nav class="@container/breadcrumb flex" aria-label="breadcrumbs">
    <ul class="flex overflow-hidden">
      <VBreadcrumbItem link="/app/aanvraag/recente-activiteiten/">Dashboard</VBreadcrumbItem>

      <VBreadcrumbItem
        v-for="{ link, name, target } in props.items"
        :key="name"
        :link="link"
        :target="target"
      >
        {{ name }}
      </VBreadcrumbItem>
    </ul>
  </nav>
</template>
